import { render, staticRenderFns } from "./NewUserForm.vue?vue&type=template&id=3ad78760&scoped=true&"
import script from "./NewUserForm.vue?vue&type=script&setup=true&lang=ts&"
export * from "./NewUserForm.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./NewUserForm.vue?vue&type=style&index=0&id=3ad78760&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ad78760",
  null
  
)

export default component.exports